var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Button, Column, Div } from "react-vcomponents";
import { BaseComponent, BasicStyles, SimpleShouldUpdate, BaseComponentPlus } from "react-vextensions";
import { ShowMessageBox } from "react-vmessagebox";
import { HandleError, Observer } from "vwebapp-framework";
import { MeID } from "../../../Store/firebase/users";
import { IsAuthValid } from "mobx-firelink";
import { fire } from "Utils/LibIntegrations/MobXFirelink";
import { E } from "js-vextensions";
//import SocialButton from "react-social-button";
let UserPanel = class UserPanel extends BaseComponentPlus({}, {}) {
    render() {
        // authError: pathToJS(state.firebase, "authError"),
        // auth: helpers.pathToJS(state.firebase, "auth"),
        // const auth = State((a) => a.firebase.auth);
        // account: helpers.pathToJS(state.firebase, "profile")
        if (!IsAuthValid(fire.userInfo)) {
            return (React.createElement(Column, { style: { padding: 10, background: "rgba(0,0,0,.7)", borderRadius: "0 0 0 5px" } },
                React.createElement(Div, { mt: -3, mb: 5 }, "Takes under 30 seconds."),
                React.createElement(SignInPanel, null)));
        }
        return (React.createElement(Column, { style: { padding: 5, background: "rgba(0,0,0,.7)", borderRadius: "0 0 0 5px" } },
            React.createElement(Column, { sel: true },
                React.createElement("div", null,
                    "Name: ",
                    fire.userInfo.displayName),
                React.createElement("div", null,
                    "ID: ",
                    MeID())),
            React.createElement(Button, { text: "Sign out", mt: 5, style: { alignSelf: "flex-end", width: 100 }, onClick: () => {
                    fire.LogOut();
                } })));
    }
};
UserPanel = __decorate([
    Observer
], UserPanel);
export { UserPanel };
export function ShowSignInPopup() {
    const boxController = ShowMessageBox({
        title: "Sign in", okButton: false, cancelOnOverlayClick: true,
        message: () => {
            return (React.createElement("div", null,
                React.createElement("div", null, "Takes under 30 seconds."),
                React.createElement(SignInPanel, { style: { marginTop: 5 }, onSignIn: () => boxController.Close() })));
        },
    });
}
let SignInPanel = class SignInPanel extends BaseComponent {
    render() {
        const { style, onSignIn } = this.props;
        return (React.createElement(Column, { style: style },
            React.createElement(SignInButton, { provider: "google", text: "Sign in with Google", onSignIn: onSignIn })));
    }
};
SignInPanel = __decorate([
    SimpleShouldUpdate
], SignInPanel);
export { SignInPanel };
let SignInButton = 
// @ApplyBasicStyles
class SignInButton extends BaseComponent {
    render() {
        const { provider, text, style, onSignIn } = this.props;
        const { loading } = this.state;
        return (
        // <SocialButton social={provider} text={text} loading={loading} btnProps={{
        //	style: E({outline: "none"}, BasicStyles(this.props), style),
        //	onClick: async ()=> {
        React.createElement(Button, { text: text, style: E({ outline: "none" }, BasicStyles(this.props), style), onClick: async () => {
                this.SetState({ loading: true });
                try {
                    const account = await fire.LogIn({ provider, type: "popup" });
                    if (this.mounted == false)
                        return;
                    this.SetState({ loading: false });
                    if (onSignIn)
                        onSignIn();
                }
                catch (ex) {
                    this.SetState({ loading: false });
                    if (ex.message == "This operation has been cancelled due to another conflicting popup being opened.")
                        return;
                    HandleError(ex);
                }
            } }));
    }
};
SignInButton = __decorate([
    SimpleShouldUpdate
    // @ApplyBasicStyles
], SignInButton);
